import React from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { useEffect, useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
  import BookPanditPopupModal from "../components/BookPanditPopupModal";

function Viewall() {
  const [isMobile, setIsMobile] = useState(false);
  const [category, setCategory] = useState("");
  const [viewall, setviewall] = useState([]);
  const { id } = useParams(); // Extract the dynamic ID from the URL


  // Fetch puja list by category ID
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/api/v1/puja/list/${id}`)
      .then((response) => {
        setviewall(response.data.data.puja_list || []);
      })
      .catch((err) => {
        console.error("Error fetching Pujas list:", err.message);
      });
  }, [id]);

  // Fetch category by category id
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/api/v1/category/list/all`)
      .then((responses) => {
        const allCategories = responses.data.data.category_list || [];
        const filteredCategory = allCategories.find(
          (category) => category.id === parseInt(id)
        );
        setCategory(filteredCategory || []);
        console.log(filteredCategory);
      })
      .catch((err) => {
        console.error("Error fetching data:", err.message);
      });
  }, [id]);

  // Detect screen size
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <Header />

      <section className="mt-5 mb-5 pt-5">
        <div
          style={{ position: "relative", paddingBottom: "10px" }}
          className="container"
        >
          <div className="d-flex flex-column">
            {/* Heading */}
            <div className="d-flex justify-content-center align-items-center flex-wrap">
              <h3
                style={
                  isMobile
                    ? {
                        color: "#E3952A",
                        fontSize: "28px",
                        fontWeight: "600",
                        marginBottom: "10px",
                      }
                    : {
                        color: "#6B2A00",
                        fontSize: "32px",
                        fontWeight: "600",
                        marginBottom: "10px",
                      }
                }
              >
                {category.category_name}
              </h3>
            </div>

            {/* Subtitle Text */}
            <p
              style={{
                color: "#E3952A",
                fontSize: "16px",
                marginTop: "10px",
                marginBottom: "15px",
                textAlign: "center",
              }}
              className="d-none d-md-block"
            >
              Explore all {category.category_name} Pujas
            </p>

            {/* Border Line */}
            <div
              style={{
                width: "100%",
                height: "2px",
                marginTop: "5px",
                marginBottom: "20px",
                background:
                  "linear-gradient(to right, #8B5E3B 20%, #D3B8A1 20%)",
              }}
            ></div>
          </div>
        </div>

        <div className="container">
          <div
            style={{
              display: "flex",
              justifyContent: "start",
              flexWrap: "wrap",
              gap: "20px",
            }}
          >
            {viewall.map((item, index) => (
              <div
                key={index}
                className="event-card"
                style={{ flexBasis: "calc(25% - 20px)", minWidth: "280px" }}
              >
                <img
                  src={item.puja_image}
                  alt={item.puja_name}
                  className="event-img"
                />
                <div className="event-content">
                  <h2>{item.puja_name}</h2>
                  <p>{item.description}</p>
                  <button className="botton"   onClick={() => {

    window.dispatchEvent(
      new CustomEvent(
        "openBookPanditModal",
        {
          detail: {
            pujaId: item.id
          }
        }
      )
    );

  }}
>Book A Pandit Today!</button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
      <BookPanditPopupModal />
    </>
  );
}

export default Viewall;